import { IconButton, Tooltip } from '@mui/material';
import ViewListIcon from '@mui/icons-material/ViewList';
import ViewHeadlineIcon from '@mui/icons-material/ViewHeadline';
import { useTranslation } from 'react-i18next';
import type { LegendDisplayMode } from '../types';

interface LegendToggleButtonProps {
  mode: LegendDisplayMode;
  onToggle: () => void;
}

export const LegendToggleButton = ({
  mode,
  onToggle,
}: LegendToggleButtonProps) => {
  const { t } = useTranslation();
  const isLegendMode = mode === 'legend';
  return (
    <Tooltip
      title={
        isLegendMode
          ? t('LegendToggleButton.showLabelsOnAxis')
          : t('LegendToggleButton.moveLabelsBelow')
      }
    >
      <IconButton
        onClick={onToggle}
        sx={{
          color: isLegendMode ? 'primary.main' : 'action.disabled',
          padding: '4px',
        }}
        aria-label={t('LegendToggleButton.toggleCategoryLabels')}
      >
        {isLegendMode ? <ViewHeadlineIcon /> : <ViewListIcon />}
      </IconButton>
    </Tooltip>
  );
};
